// extracted by mini-css-extract-plugin
module.exports = {"divider":"google-sign-in_divider__RpCsw","dividerText":"google-sign-in_dividerText__i2Xsz","secondary":"google-sign-in_secondary__p9Kql"};